import { c as _c } from "react/compiler-runtime";
import { useControls } from 'react-zoom-pan-pinch';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
export function Controls() {
  const $ = _c(19);
  const {
    zoomIn,
    zoomOut,
    resetTransform
  } = useControls();
  let t0;
  if ($[0] !== zoomIn) {
    t0 = () => zoomIn();
    $[0] = zoomIn;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PhosphorIcon name="magnifying-glass-plus" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <button className="cursor-zoom-in p-0 flex" onClick={t0} title="Zoom in">{t1}</button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== zoomOut) {
    t3 = () => zoomOut();
    $[5] = zoomOut;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PhosphorIcon name="magnifying-glass-minus" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <button className="cursor-zoom-out p-0 flex" onClick={t3} title="Zoom out">{t4}</button>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== resetTransform) {
    t6 = () => resetTransform();
    $[10] = resetTransform;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PhosphorIcon name="arrows-clockwise" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <button className="cursor-pointer p-0 flex" onClick={t6} title="Reset">{t7}</button>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t8) {
    t9 = <div className="absolute top-4 left-4 z-2 flex flex-row gap-2 p-2 bg-black/[32%] rounded-md text-white items-center text-[24px]">{t2}{t5}{t8}</div>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}